const firebaseConfig = {
    apiKey: 'AIzaSyCLmU7AVWz2SxfupkQgTD1YfpriTHSYxRk',
    authDomain: 'e-make-over.firebaseapp.com',
    projectId: 'e-make-over',
    storageBucket: 'e-make-over.appspot.com',
    messagingSenderId: '394992182519',
    appId: '1:394992182519:web:55e7d56c2cbf2ddc391ff2',
};

export default firebaseConfig;
